import { queryOptions } from '@tanstack/react-query';
import { cmsQueryKeys } from '../cms/cmsQueryKeys';
import { getPrimaryNavigation } from '../cms/getPrimaryNavigation';

export const primaryNavigationQueryOptions = queryOptions({
  queryKey: cmsQueryKeys.getPrimaryNavigation,
  queryFn: getPrimaryNavigation,
  staleTime: Infinity,
});
